"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateActivity = void 0;
const core_1 = require("@zodios/core");
const zod_1 = require("zod");
const voice_1 = require("../core/voice");
const updateActivityPayloadSchema = zod_1.z.object({
    moduleId: zod_1.z.string().optional(),
    display: zod_1.z
        .object({
        title: zod_1.z.string().optional(),
        voice: voice_1.voiceSchema.deepPartial().optional(),
        backgroundUrl: zod_1.z.string().optional(),
    })
        .partial(),
    metadata: zod_1.z
        .object({
        difficulty: zod_1.z.string().optional(),
        skill: zod_1.z.string().optional(),
    })
        .optional(),
    strategy: zod_1.z.string().optional(),
    index: zod_1.z.number().optional(),
    // TODO: Define proper schema for activity content instead of using z.any()
    content: zod_1.z.any().optional(),
});
exports.updateActivity = (0, core_1.makeEndpoint)({
    method: "put",
    path: "/private/activity/:activityId",
    alias: "updateActivity",
    parameters: [
        {
            name: "body",
            type: "Body",
            schema: updateActivityPayloadSchema,
        },
    ],
    response: zod_1.z.object({ success: zod_1.z.boolean() }),
});
//# sourceMappingURL=updateActivity.js.map